import {computed, makeObservable, observable} from 'mobx';
import {ScoresBarWidgetTerms} from "../../scores-bar-widget.terms";
import {BaseModel} from "../../../../infrastructure/models/base-model";
import {DatetimeUtils} from "../../../../infrastructure/utils/datetime-utils";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {SCORES_BAR_SOURCES} from "../../scores-bar-widget.consts";
import {AppModuleState} from "../../../../core/app/models/app-module.state";
import {ScoresBarWidgetConfig} from "../../scores-bar-widget.config";

export class ScoresBarWidgetScoresModel extends BaseModel {
  @observable context: Number;
  @observable date: Date;
  @observable isLive: Boolean;
  @observable currentLinkModel: BaseLinkModel;
  @observable currentFilterIndex: Number;

  terms: ScoresBarWidgetTerms;
  datetimeUtils: DatetimeUtils;

  constructor(
    context: Number,
    currentLinkModel: BaseLinkModel,
    terms: ScoresBarWidgetTerms,
    datetimeUtils: DatetimeUtils,
    appState: AppModuleState,
    config: ScoresBarWidgetConfig
  ) {
    super();

    this.context = context;
    this.currentLinkModel = currentLinkModel;
    this.terms = terms;
    this.datetimeUtils = datetimeUtils;
    this.currentFilterIndex = 0;
    this.appState = appState;
    this.config = config;

    makeObservable(this);
  }

  @computed get dateLabel(): String {
    return console.error(this.constructor.name + 'Implementation is missing: scores-component');
  }

  @computed get arrowPrevLabel(): String {
    return console.error(this.constructor.name + 'Implementation is missing: arrow-labels');
  }

  @computed get arrowNextLabel(): String {
    return console.error(this.constructor.name + 'Implementation is missing: arrow-labels');
  }

  @computed get linkModel(): BaseLinkModel {
    return console.error(this.constructor.name + 'Implementation is missing: link-model');
  }

  @computed get linkType(): BaseLinkModel {
    return console.error(this.constructor.name + 'Implementation is missing: link-type');
  }

  @computed get entityId(): Number {
    return console.error(this.constructor.name + 'Implementation is missing: entity-id');
  }

  @computed get arrowsClick(): String {
    return console.error(this.constructor.name + 'Implementation is missing: arrows-handler');
  }

  @computed get validRoutes(): Array<String> {
    return console.error(this.constructor.name + 'Implementation is missing: valid-routes');
  }

  @computed get shouldRenderLiveToggle(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: should-render-live-toggle');
  }

  @computed get shouldRenderDate(): Boolean {
    return console.error(this.constructor.name + 'Implementation is missing: should-render-date');
  }

  @computed get arrowClickType(): String {
    return console.error(this.constructor.name + 'Implementation is missing: arrow-click-type');
  }

  @computed get hasDropdown(): Boolean {
    return false;
  }

  @computed get isToday() {
    return this.datetimeUtils.isToday(this.date)
  }

  @computed get source(): Array<String> {
    return SCORES_BAR_SOURCES[this.context];
  }

  toString() {
    return `${this.constructor.name}: ${this.entityId}`;
  }

  equals(model: ScoresBarWidgetScoresModel) {
    let equals = true;

    equals &= model.context === this.context;
    equals &= model.entityId === this.entityId;

    return equals;
  }
}
